import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthStore } from 'features/user/store/auth.store';
import { UserService } from 'features/user/services/user.service';

@Component({
  selector: 'app-impersonation-banner',
  standalone: true,
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.scss'],
  imports: [CommonModule, MatButtonModule, MatIconModule],
})
export class ImpersonationBannerComponent {
  private authStore = inject(AuthStore);
  private userService = inject(UserService);

  isImpersonating = this.authStore.isImpersonating;
  impersonation = this.authStore.impersonation;

  exit(): void {
    // Restore admin's tokens in-memory + sessionStorage.
    this.authStore.exitImpersonation();
    // Re-fetch /self (now with admin's token) and overwrite sessionStorage.__user
    // before reload — otherwise the target user's cached userInfo/profiles bleed
    // back into the admin's restored session on bootstrap.
    this.userService.getUserData().subscribe({
      next: (userData) => {
        const data = {
          ...userData,
          activeProfile: userData.userInfo?.defaultProfile,
        };
        sessionStorage.setItem('__user', JSON.stringify(data));
        window.location.href = '/system-admin/security/users';
      },
      error: () => {
        // Fallback: clear the stale target-user cache and reload to /login
        sessionStorage.removeItem('__user');
        window.location.href = '/login';
      },
    });
  }
}
